import type { BankAccountDto } from '#modules/Bank/Bank.types'

import { MultipleChoice } from '@monthio/design-system'
import { useBankBanner } from '#modules/Bank/useBankHooks'
import { useMemo } from 'react'
import styled from 'styled-components'

export interface SelectedAccount {
	accountNumber: string | undefined
	accountId: string
}

export interface BankSessionListItemProps {
	accounts: BankAccountDto[]
	deselectedAccountIds: string[]
	bankId: number
	handleAccountSelection: (accountId: string, deselected: boolean) => void
	handleAccountsSelection: (e: {
		selected: string[]
		deselected: string[]
	}) => void
}

export const BankSessionContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	row-gap: 16px;

	${(props) => props.theme.breakpoints.up('sm')} {
		grid-template-columns: 250px 1fr;
		column-gap: 16px;
	}
`
const BankLogoImage = styled.img`
	width: 167px;
	box-shadow: ${(props) => props.theme.shadows[24]};
	border-radius: ${(props) => props.theme.shape.borderRadius}px;

	${(props) => props.theme.breakpoints.up('sm')} {
		width: 250px;
	}
`

export const BankSessionListItem = (props: BankSessionListItemProps) => {
	const { alt, banner } = useBankBanner(props.bankId)

	const initiallySelected = useMemo(
		() =>
			props.accounts
				.filter((a) => a.selected && a.accountId)
				.map((x) => x.accountId),
		[],
	)

	return (
		<BankSessionContainer>
			<div>
				<BankLogoImage src={banner} alt={alt} />
			</div>
			<MultipleChoice
				type="checkbox"
				choicesOrientation="vertical"
				defaultValue={initiallySelected}
				choices={props.accounts.map((account) => ({
					label: `${account.name} - ${account.owner}`,
					description: `${account.type} - ${account.accountNumber}`,
					value: account.accountId,
					startDecorator: null,
				}))}
				fieldName="accountName"
				onChange={(newValue) =>
					props.handleAccountsSelection({
						selected: newValue,
						deselected: props.accounts
							.filter((account) => !newValue.includes(account.accountId))
							.map((account) => account.accountId),
					})
				}
			/>
		</BankSessionContainer>
	)
}
